import { commentsData } from "@/mocks/homeData";

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">💬 吃瓜群众说</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">来自真实用户的吃瓜体验分享</p>

        <div className="space-y-4 md:space-y-5">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-accent-500 transition-colors">
                      <i className="ri-thumb-up-line"></i> {comment.likes}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-foreground-700 transition-colors">
                      <i className="ri-chat-1-line"></i> 回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}